import store from '../store/store';
import { isBulkActionRunning, isBulkActionUninitialized } from 'owa-bulk-action-store';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
export default function canRunCurrentEditRule() {
    // Early exit if a bulk action is already running in inbox
    if (isBulkActionRunning(folderNameToId('inbox')) ||
        isBulkActionUninitialized(folderNameToId('inbox'))) {
        return false;
    }
    // Only 'from' is currently supported, so only 1 conditional clause is allowed
    if (store.inboxRulesEditState.conditionalClauseIds.length > 1) {
        return false;
    }
    var conditionalClause = store.inboxRulesEditState.clauseMap.get(store.inboxRulesEditState.conditionalClauseIds[0]);
    // must be 'from' type
    if (conditionalClause.clauseType != 'from') {
        return false;
    }
    var recipientWellState = conditionalClause.clauseValue;
    // make sure at least one persona
    if (recipientWellState.recipients.length == 0) {
        return false;
    }
    // DLs not supported
    for (var _i = 0, _a = recipientWellState.recipients; _i < _a.length; _i++) {
        var recipient = _a[_i];
        var mailbox = recipient.persona.EmailAddress;
        if (mailbox.MailboxType == 'PrivateDL' ||
            mailbox.MailboxType == 'PublicDL' ||
            mailbox.MailboxType == 'GroupMailbox') {
            return false;
        }
    }
    // Action must be a 'move to folder' type
    if (store.inboxRulesEditState.actionClauseIds.length > 1) {
        return false;
    }
    var actionClause = store.inboxRulesEditState.clauseMap.get(store.inboxRulesEditState.actionClauseIds[0]);
    if (actionClause.clauseType == 'moveTo' ||
        actionClause.clauseType == 'delete' ||
        actionClause.clauseType == 'junk') {
        return true;
    }
    return false;
}
//# sourceMappingURL=canRunCurrentEditRule.js.map